import React from 'react'
import { ConnectProps } from '@/react-app-env';
import qs from 'qs';
import { useMount } from 'react-use';
import { wxLogin } from '@/services/userServices';
import { Toast } from 'antd-mobile';

const RedirectPage = (props: ConnectProps) => {
  const { location } = props;
  const param = qs.parse(location.search.replace('?', ''));

  useMount(() => {
      if (param?.code && param?.state === 'wechatlogin') {
        wechatLogin(param.code as string, 'h5');
      }
      if (param?.code && param?.state === 'wechatlogin_web') {
        wechatLogin(param.code as string, 'web');
      }
  })

  const wechatLogin = async (code: string, from: string) => {
    const result = await wxLogin(code, from);
    if (result != null) {
      Toast.info('登录成功');
      localStorage.setItem('user', JSON.stringify(result));
      const top = window.top || window;
      top.location.href = '/';
    }
  }

  return (
    <div>
    </div>
  )
}

export default RedirectPage;
